module.exports = {
    pt: { title: 'Áudio' },
    en: { title: 'Audio' }
  }